import * as React from "react";
import axios from "axios";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link as RouteLink } from "react-router-dom";
import AuthContext from "./../../context/auth-context";
import { AddToHomeScreen } from 'react-pwa-add-to-homescreen';

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://tokaiiran.com/">
        tokaiiran.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "IRANYekan",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

const SignInSide = (props) => {
  React.useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundColor = "#fff";
  }, []);
  const viaSms = React.useState(true)[0];
  const [codeSent, setCodeSent] = React.useState();
  const authContext = React.useContext(AuthContext);
  const submitInputRef = React.useRef(null);

  const handleSubmitSms = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const code = data.get("code");
    if (code !== "" && code.length === 4 && code === codeSent.code.toString()) {
      authContext.messageType("success");
      authContext.login(codeSent);
      authContext.message(codeSent.message);
      authContext.showSnackBar(true);
      props.history.replace("/");
    } else {
      authContext.message("خطایی رخ داده است!");
      authContext.messageType("warning");
      authContext.showSnackBar(true);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    const password = data.get("password");
    const mobile = data.get("mobile");
    if (viaSms) {
      if (mobile !== "" && mobile.length === 11) {
        axios
          .post("https://admin.tokaiiran.com/api/send-sms", {
            mobile,
          })
          .then((res) => {
            const data = res.data;
            if (data.status !== 200) {
              authContext.messageType("warning");
            } else {
              setCodeSent(data);
              document.getElementById("code").value = "";
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      if (email !== "" && password !== "") {
        axios
          // .post("http://api.localhost:5000/login", {
          .post("https://admin.tokaiiran.com/api/login", {
            email,
            password,
          })
          .then((res) => {
            const data = res.data;
            if (data.status !== 200) {
              authContext.messageType("warning");
            } else {
              authContext.messageType("success");
              authContext.login(data);
              props.history.replace("/");
            }
            authContext.message(data.message);
            authContext.showSnackBar(true);
          })
          .catch((err) => console.log(err));
      }
    }
  };

  const emailField = (
    <>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="ایمیل"
        name="email"
        dir="ltr"
        autoComplete="email"
        autoFocus
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label="کلمه عبور"
        type="password"
        id="password"
        dir="ltr"
        autoComplete="current-password"
      />
    </>
  );
  const codeLenghtCheckHandler = event => {
    if(event.target.value.length === 4 ) {
      console.log(submitInputRef.current.click())
    }
  }
  const mobileField = (
    <TextField
      helperText="مثال: 09121234567"
      margin="normal"
      required
      fullWidth
      id="mobile"
      label="موبایل"
      name="mobile"
      dir="ltr"
      autoFocus
      inputProps={{
        autoComplete: 'mobile',
        maxLength: "11"
      }}
    />
  );

  return (
    <ThemeProvider theme={theme}>
      <AddToHomeScreen translate={{ chromiumInstall: 'آیا مایل به نصب اپلیکیشن هستید؟', buttonInstall: 'نصب', safariTapShare: 'روی آیکن Share بزنید', safariAddHomeScreen: 'و گزینه "Add to home screen" را انتخاب کنید'}} />
      <Grid container component="main" sx={{ minHeight: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url(https://picsum.photos/640/780)",
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              alt="Tokai Iran"
              src="/assets/images/logo01.png"
              sx={{ width: 34, height: 41, borderRadius: 0 }}
            />
            <Typography component="h1" variant="h5" sx={{ my: 1 }}>
              ورود به برنامه
            </Typography>
            {codeSent ? (
              <Box
                component="form"
                onSubmit={handleSubmitSms}
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="code"
                  label="کد ارسالی"
                  name="code"
                  dir="ltr"
                  onChange={codeLenghtCheckHandler}
                  autoFocus
                  inputProps={{
                    autoComplete:"one-time-code",
                    maxLength:"4"
                  }}
                />
                <Button
                  ref={submitInputRef}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  ورود
                </Button>
              </Box>
            ) : (
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ mt: 1 }}
              >
                {!viaSms ? emailField : mobileField}
                <FormControlLabel
                  className="label-has-checkbox"
                  control={<Checkbox value="remember" color="primary" />}
                  label="مرا به خاطر بسپار"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {viaSms ? "ارسال کد" : "ورود"}
                </Button>
                <Grid container className="rtl">
                  {/* <Grid item xs={12} md={6} sx={{ mb: 2 }}>
                    <Button onClick={() => setViaSms((prev) => !prev)}>
                      {viaSms ? "ورود با کلمه عبور" : "ورود با رمز یکبار مصرف"}
                    </Button>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <Link component={RouteLink} to="/signup" variant="body2">
                      {"هنوز ثبت نام نکرده اید؟ ثبت نام"}
                    </Link>
                  </Grid>
                </Grid>
                <Copyright sx={{ mt: 5 }} />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default SignInSide;
